export const zIndices = {
    nav: 4,
    default: 3,
    fireworks: 2,
    splash: 1,
    toast: 5,
}
